import { AppState } from '../../types';

export const selectPasswordRecoveryForm = (state: AppState) => state.passwordRecovery.form;
export const selectPasswordRecovery = (state: AppState) => state.passwordRecovery.recover;
export const selectResend = (state: AppState) => state.passwordRecovery.resend;
